var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
/* eslint-disable */
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { StyleSheet } from 'aphrodite';
import { bind } from 'bind-decorator';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { ZIndex } from '../../constants';
import { LabelSwitchButton } from '../../molecules/label_switch_button';
import { MediaBreakPointUp } from '../../styles';
var AutoPlayButton = observer(/** @class */ (function (_super) {
    __extends(AutoPlayButton, _super);
    function AutoPlayButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AutoPlayButton.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var label = "\u81EA\u52D5\u518D\u751F".concat(this.props.vm.isAutoPlayNextVideo ? 'ON' : 'OFF');
            return (React.createElement("div", { className: "vjs-auto-play-button" },
                React.createElement(LabelSwitchButton, { classObject: styles.autoPlaySetting, label: label, onClick: this.props.onSwitchIsAutoPlay, isOn: this.props.vm.isAutoPlayNextVideo })));
        }
    });
    return AutoPlayButton;
}(React.Component)));
var VjsAutoPlayButtonVM = /** @class */ (function () {
    function VjsAutoPlayButtonVM() {
        Object.defineProperty(this, "isAutoPlayNextVideo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this, {
            isAutoPlayNextVideo: observable,
        });
    }
    return VjsAutoPlayButtonVM;
}());
var VjsAutoPlayButton = /** @class */ (function (_super) {
    __extends(VjsAutoPlayButton, _super);
    function VjsAutoPlayButton(player, options) {
        var _this = _super.call(this, player, options) || this;
        Object.defineProperty(_this, "autoPlayButtonOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "autoPlayButtonPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "vm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        _this.autoPlayButtonOptions = options;
        _this.autoPlayButtonPlayer = player;
        _this.vm = new VjsAutoPlayButtonVM();
        _this.fetchIsAutoPlay();
        _this.mount = _this.mount.bind(_this);
        _this.autoPlayButtonPlayer.ready(function () {
            _this.mount();
        });
        return _this;
    }
    Object.defineProperty(VjsAutoPlayButton.prototype, "onSwitchIsAutoPlay", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.autoPlayButtonOptions.apiClient.UpdateViewingSetting(!this.vm.isAutoPlayNextVideo);
                    this.setIsAutoPlay(!this.vm.isAutoPlayNextVideo);
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(VjsAutoPlayButton.prototype, "fetchIsAutoPlay", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var profile;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.autoPlayButtonOptions.apiClient.fetchMypageProfile()];
                        case 1:
                            profile = _a.sent();
                            this.setIsAutoPlay(profile.isAutoPlayNextVideo);
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(VjsAutoPlayButton.prototype, "setIsAutoPlay", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isAutoPlay) {
            if (this.autoPlayButtonPlayer.isDisposed())
                return null;
            this.vm.isAutoPlayNextVideo = isAutoPlay;
            var result = this.autoPlayButtonPlayer.getChild('VjsResult');
            result.videoResultOptions.resultOptions.vm.setIsAutoPlay(isAutoPlay);
        }
    });
    Object.defineProperty(VjsAutoPlayButton.prototype, "mount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var root = ReactDOM.createRoot(this.el());
            root.render(React.createElement(AutoPlayButton, { vm: this.vm, onSwitchIsAutoPlay: this.onSwitchIsAutoPlay }));
        }
    });
    __decorate([
        bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VjsAutoPlayButton.prototype, "onSwitchIsAutoPlay", null);
    __decorate([
        bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VjsAutoPlayButton.prototype, "fetchIsAutoPlay", null);
    __decorate([
        bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], VjsAutoPlayButton.prototype, "setIsAutoPlay", null);
    return VjsAutoPlayButton;
}(videojs.getComponent('Component')));
export default VjsAutoPlayButton;
var styles = StyleSheet.create({
    autoPlaySetting: (_a = {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'row',
            top: 16,
            right: 16,
            zIndex: ZIndex.VideoPlayButton
        },
        _a[MediaBreakPointUp.MD] = {
            right: 24,
        },
        _a),
});
